import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Import Link și useNavigate
import styles from './Header.module.css';
import logoLight from '../assets/omd.png'; // Asigură-te că ai logo-ul pentru modul light
import logoDark from '../assets/omd.png'; // Asigură-te că ai logo-ul pentru modul dark

const Header = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const navigate = useNavigate(); // Hook pentru navigare

	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	const navigateTo = (path) => {
		navigate(path);
		setIsMenuOpen(false); // Închide meniul mobil după navigare
	};

	return (
		<header className={styles.header}>
			<button className={styles.logoButton}>
				<img
					src={logoLight}
					alt='OMD Webdesign Logo'
					className={styles.logo}
				/>
			</button>
			<nav className={styles.desktopNav}>
				<ul>
					<li>
						<button
							className={styles.navButtonHome}
							onClick={() => navigateTo('/')}
						>
							Home
						</button>
					</li>
					<li>
						<button
							className={styles.navButtonAbout}
							onClick={() => navigateTo('/about')}
						>
							About
						</button>
					</li>
					<li>
						<button
							className={styles.navButtonProjects}
							onClick={() => navigateTo('/projects')}
						>
							Projects
						</button>
					</li>
					<li>
						<button
							className={styles.navButtonContact}
							onClick={() => navigateTo('/contact')}
						>
							Contact
						</button>
					</li>
				</ul>
			</nav>
			<button className={styles.menuButton} onClick={toggleMenu}>
				☰
			</button>
			{isMenuOpen && (
				<nav className={styles.mobileNav}>
					<ul>
						<li>
							<button
								className={styles.mobileNavButton1}
								onClick={() => navigateTo('/')}
							>
								Home
							</button>
						</li>
						<li>
							<button
								className={styles.mobileNavButton2}
								onClick={() => navigateTo('/about')}
							>
								About
							</button>
						</li>
						<li>
							<button
								className={styles.mobileNavButton3}
								onClick={() => navigateTo('/projects')}
							>
								Projects
							</button>
						</li>
						<li>
							<button
								className={styles.mobileNavButton4}
								onClick={() => navigateTo('/contact')}
							>
								Contact
							</button>
						</li>
					</ul>
				</nav>
			)}
		</header>
	);
};

export default Header;
